// extracted by mini-css-extract-plugin
export default {"logoDocProps":"styles_logoDocProps__RXhDo","docPropsItem":"styles_docPropsItem__KGh++"};